<template>
  <div class="mobile-category-nav">
    <div class="category-scroll-container" ref="scrollContainer">
      <button
        v-for="category in categories"
        :key="category.id"
        class="category-item"
        :class="{ active: activeCategory === category.id }"
        @click="selectCategory(category)"
      >
        {{ category.name }}
      </button>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { useRouter } from 'vue-router'

const API_BASE_URL = 'https://ott.no1news.in'

export default {
  name: 'MobileCategoryNav',
  setup() {
    const router = useRouter()
    return { router }
  },
  data() {
    return {
      categories: [],
      activeCategory: null
    }
  },
  mounted() {
    this.fetchCategories()
  },
  methods: {
    capitalizeText(text) {
      if (!text) return ''
      return text.split(/[\s-]+/).map(word => {
        const specialWords = ['HD', 'UHD', '4K', 'TV', 'II', 'III', 'IV', 'SPY']
        if (specialWords.includes(word.toUpperCase())) {
          return word.toUpperCase()
        }
        const minorWords = ['a', 'an', 'the', 'and', 'but', 'or', 'for', 'nor', 'in', 'to', 'on', 'at', 'by', 'of']
        if (minorWords.includes(word.toLowerCase())) {
          return word.toLowerCase()
        }
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
      }).join(' ')
    },
    async fetchCategories() {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/categories/active/`)
        this.categories = response.data
          .filter(category => ![19].includes(category.id))
          .map(category => ({
            ...category,
            name: this.capitalizeText(category.name)
          }))
      } catch (error) {
        console.error('Error fetching categories:', error)
        this.categories = []
      }
    },
    selectCategory(category) {
      this.activeCategory = category.id
      this.router.push({
        name: 'CategoryVideos',
        params: { id: category.id }
      })
    }
  }
}
</script>

<style scoped>
.mobile-category-nav {
  display: none;
  background: #000;
  position: relative;
  z-index: 100;
}

/* Only show on mobile */
@media (max-width: 900px) {
  .mobile-category-nav {
    display: block;
  }
}

.category-scroll-container {
  display: flex;
  overflow-x: auto;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  gap: 8px;
  padding: 10px 12px;

  /* Hide scrollbar */
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.category-scroll-container::-webkit-scrollbar {
  display: none;
}

.category-item {
  flex-shrink: 0;
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 500;
  color: #fff;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 20px;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s ease;
}

.category-item:hover {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.3);
}

.category-item:active {
  transform: scale(0.95);
}

.category-item.active {
  background: linear-gradient(45deg, #c30059, #ff0077);
  border-color: transparent;
  color: #fff;
  font-weight: 600;
  box-shadow: 0 2px 8px rgba(195, 0, 89, 0.4);
}

/* Smaller screens */
@media (max-width: 480px) {
  .category-scroll-container {
    gap: 6px;
    padding: 8px 10px;
  }

  .category-item {
    padding: 6px 14px;
    font-size: 12px;
    border-radius: 16px;
  }
}
</style>
